angular.module("Main").controller("PaymentPayPalTerminSuccessController", ["$rootScope", "$scope", "$state", "$stateParams", "$window", "$localStorage", "$location", "$translate", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $window, $localStorage, $location, $translate, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            //unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
        });

        vm.bookingLost = false;
        vm.cashBack = false;
        vm.cookies = SessionService.checkSession();
        //vm.currentUser = SessionService.getUserData();
        vm.currentUser = $localStorage.user;

        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = false;
        vm.isTermin = true;
        vm.isPayPal = true;
        vm.isPayed = true;


        if (!SessionService.getSessionId()) {
            $state.go("angebot", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();

        function init() {
            vm.hasError = false;

            BookingService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                if (status.status === 'TIMEOUT') {
                    vm.bookingLost = true;
                    vm.cashBack = false;
                } else {
                    vm.dataMeeting = ({
                        OrderNr: $stateParams.oid,
                        Name: vm.status.artikel,
                        PreisZahl: vm.status.preis,
                        Day: vm.status.start,
                        End: vm.status.ende,
                        PersonNr: vm.status.personNr,
                        RessourcenIds: vm.status.ressourcesIds,
                        TerminNr: vm.status.terminNr
                    });
                    vm.dataMeeting.OrderNr = $stateParams.oid;

                    if (status.status !== 'CAPTURED') {

                        BookingService.confirmReservation($stateParams.oid, $translate.use()).then(function (data) {
                            vm.isPayment = true;
                            vm.zahlmethode = 'PayPal';
                            if ((data && !_.isEmpty(data.rechnungsNr))) {
                                vm.dataMeeting.RechnungsNr = data.rechnungsNr;
                            }
                            if (data.data && !_.isEmpty(data.data.rechnungsNr)) {
                                vm.dataMeeting.RechnungsNr = data.data.rechnungsNr;
                            }

                        }).catch(function (error) {
                            $state.go("payment_pp_fail", {cid: $stateParams.cid, message: error, id: $stateParams.id, oid: $stateParams.oid});
                            vm.hasError = true;
                            throw error;
                        }).then(function () {
                            getDataByRIDForConfirm();
                            PaymentService.capturePaymentPayPal($stateParams.oid).then(function () {
                                vm.captured = true;
                                BookingService.saveAppointmentHistory(vm.dataMeeting.TerminNr, 1, 5);
                                BookingService.saveAppointmentHistory(vm.dataMeeting.TerminNr, 8, 5,
                                    {orderId: $stateParams.oid});
                            })
                        })
                    } else {
                        vm.isPayment = true;
                        vm.zahlmethode = 'PayPal';
                        vm.dataMeeting.RechnungsNr = vm.status.RechnungsNr;
                        vm.dataMeeting.BookingNr = vm.status.BookingNr;
                        vm.meetingData = vm.dataMeeting;
                        let end = vm.meetingData.End;
                        let timeEnd = moment(vm.meetingData.End).format("HH:mm");
                        if(timeEnd === '00:00') {
                            let newEnd = moment(end).subtract('minutes', 1).format();
                            vm.meetingData.End = new Date(newEnd);
                        }
                        getDataByRIDForConfirm();
                    }
                }
            }).catch(function (error) {
                $state.go("payment_pp_fail", {cid: $stateParams.cid, message: error, id: $stateParams.id,oid: $stateParams.oid});
                vm.hasError = true;
                throw error
            })
        }


        function getDataByRIDForConfirm() {
            vm.member = {};
            vm.personNr = vm.dataMeeting.PersonNr;
            let userData = $localStorage.user;
            BookingService.getUserDetails(userData.uid).then(function (data) {
                vm.memberNr = vm.personNr;
                vm.isMember = $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
                vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
                vm.member = $localStorage.user;
                vm.member.firstname = $localStorage.user.Firstname;
                vm.member.lastname = $localStorage.user.Lastname;
                vm.member.email = $localStorage.user.Email;
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.username = data.firstname + " " + data.lastname;
                    vm.hideLogin = true;
                    $rootScope.$emit("login");
                }
            }).then(function () {
                var arr =  vm.dataMeeting.RessourcenIds.slice(1, -1);
                var ids = _.split(arr, '"');
                BookingService.getResourceNamesPayPal(ids).then(function (data) {
                    vm.ressources = _.join(_.map(_.sortBy(data, "Bezeichnung"),  "Bezeichnung"), " ,");
                }).then(function () {
                    vm.meetingData = vm.dataMeeting;
                })
            });
        }

    }]);